import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { v4 } from "uuid";
import {
  // FaChevronDown,
  FaTrash,
} from "react-icons/fa6";
import Stepper from "../components/partials/steps";
import Logo from "../assets/icons/logo.svg";
import Input, { TextArea } from "../components/partials/inputs";
import PrimaryBtn, { Loaded } from "../components/partials/btn";
import Done from "../assets/icons/_Step icon base_done.svg";
import Pending from "../assets/icons/_Step icon base.svg";
import Stationery from "../assets/icons/_Step icon base_stationary.svg";
import Plus from "../assets/icons/plus.svg";
import MultiSelectDropdown, {
  FlowSelectDropdown,
} from "../components/partials/select";
import SuccessModal from "../components/modals/successmodal";
import useAuthStore from "../data/stores/authStore";
import useErrorStore from "../data/stores/errorStore";
import { apiCall, numberWithCommas, useApiCall } from "../data/useFetcher";
import moment from "moment";
import { useRequestStore } from "../data/stores/loggerStore";
import {
  dataSecurityList,
  effectivenessList,
  informationCollectionToolList,
  oftenCollectedList,
  systemInformAreaList,
  systemInformKPIList,
} from "../utils/types";

const dataCollectionDetails = [
  {
    question: "Name of the tool used to collect data",
    answer: "Lorem Ipsum",
    key: "toolUsedToCollectData",
  },
  {
    question: "What technology is used by the tool to collect information",
    answer: "Lorem Ipsum",
    key: "informationCollectionTool",
  },
  {
    question: "How often is data collected",
    answer: "Monthly",
    key: "oftenCollected",
  },
  {
    question: "How well does the data collection tool serve its purpose?",
    answer: "Very Effective",
    key: "dataCollectionToolPurposeServe",
  },
];

const dataFlowDetails = [
  {
    question: "Which department feeds data to this system*",
    answer: "Finance",
    key: "deptsFeedDataSystem",
  },
  {
    question: "Which system feeds data to this system*",
    answer: "Finance",
    key: "systemsFeedDataSystem",
  },
  {
    question: "Which department receives data from this system?",
    answer: "August 6, 2025",
    key: "deptReceiveData",
  },
  {
    question: "Which system receives data from this system?",
    answer: "Lorem ipsum dolor sit amet, consectetur adipiscing ",
    key: "systemReceiveData",
  },
  {
    question: "What reports are produced for decision-making?",
    answer: "Lorem ipsum dolor sit amet, consectetur adipiscing ",
    key: "reportProduced",
  },
];

const systemDetails = [
  {
    question: "Data system in use by the department",
    answer: "ERP Module",
    key: "erpModule",
  },
  {
    question: "Name of the system developer",
    answer: "Solanke Mary",
    key: "systemDeveloper",
  },
  {
    question: "Date of first installation",
    answer: "August 6, 2025",
    key: "dateInstalled",
    type: "date",
  },
  {
    question: "Amount paid for annual license fees or maintenance",
    answer: "₦500,000.00",
    key: "annualLicenseFee",
    placeholder: "Enter Annual License Fees",
    subkey: "annualLicenseFeeCurrency",
    type: "number",
  },
  {
    question: "Describe the main purpose of the system",
    answer:
      "Lorem Ipsum dolor sit amet, consectetur adipiscing elit. Proin blandit ipsum vitae enim porta, facilia scelerisque nibh pulvinar. Praesent porta faucibus dapibus. Suspendisse lobortis consequat libero id dignissim. Vivamus varius cursus nisl. Phasellus pretium turpis eros, sit amet maximus ligula facilisis nec. Nulla aliquet diam nulla, sit amet cursus tortor aliquet vitae.",
    key: "systemPurpose",
  },
];

const fitForPurposeDetails = [
  {
    question: "Level of effectiveness for this purpose",
    answer: "ERP Module",
    key: "effectivenessPurposeLevel",
  },
  {
    question: "Data Security",
    answer: "Solanke Mary",
    key: "dataSecurity",
  },
  {
    question: "Support and Training Needs",
    answer: "August 6, 2025",
    key: "supportTainingNeeds",
  },
  {
    question: "Improvement required",
    answer: "₦500,000.00",
    key: "improvementRequired",
  },
];

const externalDataSharingDetails = [
  {
    question: "Which KPI does this system inform",
    answer: "ERP Module",
    key: "systemInformKPI",
  },
  {
    question: "Which Area does this system inform",
    answer: "Solanke Mary",
    key: "systemInformArea",
  },
  {
    question:
      "Which external department and system receives data from this system",
    answer: "August 6, 2025",
    key: "deptSystemReceiveData",
  },
  {
    question:
      "How effective is the communication between this system and the one that feed it information",
    answer: "₦500,000.00",
    key: "systemCommunicationEffectiveness",
  },
];

// const tabItems = [

// 	"About",
// 	"Data Collection",
// 	"Data Flow",
// 	"External Data Sharing",
// 	"Fit For Purpose",
// ];

const tabItems = [
  {
    name: "About",
    step: 1,
    data: systemDetails,
  },
  {
    name: "Data Collection",
    step: 2,
    data: dataCollectionDetails,
  },
  {
    name: "Data Flow",
    step: 3,
    data: dataFlowDetails,
  },
  {
    name: "External Data Sharing",
    step: 4,
    data: externalDataSharingDetails,
  },
  {
    name: "Fit For Purpose",
    step: 5,
    data: fitForPurposeDetails,
  },
];

const isValid = (value: any) =>
  (Array.isArray(value) && value.length > 0) ||
  (!!value && typeof value !== "object");

export const MainFlow = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [successmodal, setSuccessmodal] = useState(false);
  const [activeTab, setActiveTab] = useState(tabItems[0]?.name);
  const steps = [
      {
        id: 0,
        title: "Data Systems",
        description: "Data systems used in the department",
        // requiredKeys: ["erpModule"],
      },
      {
        id: 1,
        title: "About Data Systems",
        description: "Data systems details",
        requiredKeys: ["erpModule"],
      },
      {
        id: 2,
        title: "Data Collection",
        description: "Data collection process",
        requiredKeys: [
          "systemDeveloper",
          "dateInstalled",
          "annualLicenseFee",
          "systemPurpose",
        ],
      },
      {
        id: 3,
        title: "Data Flow and Visualisation",
        description: "Provide details correctly",
        requiredKeys: [
          "toolUsedToCollectData",
          // "dataCollectionToolPurposeServe",
          "informationCollectionTool",
          "oftenCollected",
        ],
      },
      {
        id: 4,
        title: "External Data Sharing",
        description: "Provide details correctly",
        requiredKeys: [
          // "systemReceiveData",
          "deptReceiveData",
          "reportProduced",
          "deptsFeedDataSystem",
        ],
      },
      {
        id: 5,
        title: "Fit for Purpose",
        description: "Quality of the data system",
        requiredKeys: [
          "deptSystemReceiveData",
          "systemInformKPI",
          "systemInformArea",
          "systemCommunicationEffectiveness",
        ],
      },
      {
        id: 6,
        title: "Preview",
        description: "Preview your data before submission",
        requiredKeys: [
          // "supportTainingNeeds",
          // "improvementRequired",
          "effectivenessPurposeLevel",
          "dataSecurity",
        ],
      },
    ],
    [actualSteps, setSteps] = useState(steps);
  // const handleSubmit = (e: any) => {
  // 	e?.preventDefault();
  // 	setActiveStep(1);
  // };

  const [getSearch] = useSearchParams(),
    { user } = useAuthStore(),
    navigate = useNavigate(),
    location = useLocation(),
    [loading, setLoading] = useState<string | boolean>(false),
    { returnErrors } = useErrorStore(),
    [thisUser, setUser] = useState<any>(null),
    [modules, setModules] = useState<any[]>([]),
    [actualModule, setActualModule] = useState<any>(null),
    textChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      let { name, value } = e?.target;
      setActualModule((prev) => {
        let thisState = { ...prev, [name]: value };
        return thisState;
      });
    },
    [usecase, setUseCase] = useState<"deptReceiveData" | "deptsFeedDataSystem">(
      "deptsFeedDataSystem"
    ),
    { departmentSystem, departmentSystem2 } = useGetDepartmentSystem({
      systemSelection: actualModule,
      thisUser,
      usecase,
    });

  useEffect(() => {
    if (!getSearch?.get("email") && !user) {
      navigate("/");
    } else {
      const emailRaw = location.search.match(/[?&]email=([^&]+)/)?.[1]; // get raw encoded value
      const email = decodeURIComponent(emailRaw?.replace(/\+/g, "%2B") || "");

      let thisEmail = user?.user?.email;
      if (getSearch?.get("email")) thisEmail = email || getSearch?.get("email");
      let getAvailableUser = async () => {
        setLoading("init");

        let { response, errArr, errMsg } = await apiCall({
          type: "get",
          url: `/api/v1/auth/user/get-user-by-email?email=${encodeURIComponent(
            thisEmail
          )}&privilege=focal person`,
          noToast: true,
        });
        if (errArr) {
          setLoading(false);
          returnErrors(errArr);
          navigate("/");
          return;
        }
        if (errMsg) {
          setLoading(false);
          toast.error(errMsg);
          navigate("/");
          return;
        }
        setLoading(false);
        if (response) {
          setUser(response?.data || response);
          let listMod = response?.modules || response;
          if (listMod?.length === 0)
            listMod = [
              {
                tempId: v4(),
              },
            ];
          setModules(listMod);
          // setActualModule(listMod?.[0]);
          // navigate("/");
          return;
        }
        setLoading(false);
      };
      getAvailableUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSearch]);

  useEffect(() => {
    if (actualModule) {
      const newSteps = [
        ...steps?.map((ic) => {
          let newIC = { ...ic };
          if (ic?.title === "External Data Sharing") {
            let newRequiredKeys = [...newIC?.requiredKeys];
            if (
              departmentSystem?.docs?.find(
                (it: any) => it?.category === "erpModule"
              )?.data?.length > 0
            ) {
              newRequiredKeys?.push("systemsFeedDataSystem");
            }
            if (
              departmentSystem2?.docs?.find(
                (it: any) => it?.category === "erpModule"
              )?.data?.length > 0
            ) {
              newRequiredKeys?.push("systemReceiveData");
            }
            newIC = {
              ...newIC,
              requiredKeys: newRequiredKeys,
            };
          }
          return newIC;
        }),
      ];
      const updatedSteps = newSteps.map((step, s) => {
        const isClickAble = step?.requiredKeys?.every((key) =>
          isValid(actualModule[key])
        );

        return {
          ...step,
          isClickAble: !step?.requiredKeys
            ? true
            : !actualModule
            ? false
            : isClickAble,
        };
      });

      setSteps(updatedSteps);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actualModule, departmentSystem, departmentSystem2]);

  return (
    <div>
      {loading === "init" && <Loaded />}
      <div className="min-h-screen relative w-full flex">
        <div className="w-[30%] min-h-full bg-[#2070B8] p-8">
          <img src={Logo} alt="" className="" />
          {actualModule && (
            <div className="my-4">
              <h5 className="text-base font-normal text-[#E9D7FE]">
                You're presently filling for{" "}
              </h5>
              {/* <div className="bg-[#E8EEF3] mt-3 main-shadow main-border h-14 items-center w-56 rounded-lg flex justify-center gap-4">
					<span className="text-base font-medium text-[#3F516C]">
						{actualModule?.erpModule}
					</span>
					<FaChevronDown />
				</div> */}
              <FlowSelectDropdown
                options={modules}
                actualModule={actualModule}
                onChange={(e: any) => {
                  // Create a fresh object containing only fields from `e`
                  const newActualModule = Object.keys(e).reduce((acc, key) => {
                    acc[key] = e[key];
                    return acc;
                  }, {} as any);

                  setModules((prevModules) =>
                    prevModules.map((mod) => {
                      const modId = mod?._id || mod?.tempId;
                      const actualId =
                        actualModule?._id || actualModule?.tempId;
                      return modId === actualId ? actualModule : mod;
                    })
                  );

                  setActualModule(newActualModule);
                  setActiveStep(1);
                }}

                // onChange={(e: any) => {
                // 	setModules((prevModules: any[]) =>
                // 		prevModules?.map(mod => {
                // 			const modId = mod?._id || mod?.tempId;
                // 			const actualId =
                // 				actualModule?._id || actualModule?.tempId;
                // 			return modId === actualId ? actualModule : mod;
                // 		})
                // 	);

                // 	setActualModule(e);
                // }}
              />
            </div>
          )}
          <div className="mt-12 flex gap-6">
            <div className="flex flex-col items-center">
              {actualSteps?.map((step, index) => (
                <div key={step.id} className="flex items-center">
                  <div className="w-8">
                    <img
                      src={
                        activeStep > step?.id
                          ? Done
                          : activeStep === step?.id
                          ? Pending
                          : Stationery
                      }
                      alt=""
                      className=""
                    />

                    {index < actualSteps.length - 1 && (
                      <div className="h-10 w-0.5 my-2 mx-auto bg-gray-300"></div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="space-y-10">
              {actualSteps.map((step) => (
                <div
                  key={step.id}
                  className={`cursor-pointer`}
                  onClick={() => {
                    if (step?.title !== "Data Systems")
                      if ((step as any)?.isClickAble && actualModule)
                        setActiveStep(step.id);
                      else
                        toast.error(
                          "Please complete previous step to have access"
                        );
                  }}
                >
                  <h2 className="text-base font-medium text-white">
                    {step.title}
                  </h2>
                  <p className="text-base font-normal text-white">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          className="w-[70%] relative min-h-screen flex justify-center py-20 items-center"
          key={
            (actualModule?._id || actualModule?.tempId) +
            JSON.stringify(departmentSystem) +
            JSON.stringify(departmentSystem2)
          }
        >
          {activeStep === 0 && (
            <ActiveStep0
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              actualModule={actualModule}
              modules={modules}
              setModules={setModules}
              setActualModule={setActualModule}
              thisUser={thisUser}
            />
          )}
          {activeStep === 1 && (
            <ActiveStep1
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              actualModule={actualModule}
              textChange={textChange}
              requiredKeys={actualSteps?.[2]?.requiredKeys}
            />
          )}
          {activeStep === 2 && (
            <ActiveStep2
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              actualModule={actualModule}
              textChange={textChange}
              requiredKeys={actualSteps?.[3]?.requiredKeys}
            />
          )}
          {activeStep === 3 && (
            <ActiveStep3
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              actualModule={actualModule}
              textChange={textChange}
              requiredKeys={actualSteps?.[4]?.requiredKeys}
              departmentSystem={departmentSystem}
              departmentSystem2={departmentSystem2}
              thisUser={thisUser}
              setUseCase={setUseCase}
            />
          )}
          {activeStep === 4 && (
            <ActiveStep4
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              actualModule={actualModule}
              textChange={textChange}
              requiredKeys={actualSteps?.[5]?.requiredKeys}
              departmentSystem={departmentSystem}
            />
          )}
          {activeStep === 5 && (
            <ActiveStep5
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              actualModule={actualModule}
              textChange={textChange}
              requiredKeys={actualSteps?.[6]?.requiredKeys}
            />
          )}
          {activeStep === 6 && (
            <ActiveStep6
              setActiveStep={setActiveStep}
              activeStep={activeStep}
              actualModule={actualModule}
              setActiveTab={setActiveTab}
              setSuccessmodal={setSuccessmodal}
              activeTab={activeTab}
              thisUser={thisUser}
              modules={modules}
              setModules={setModules}
              setActualModule={setActualModule}
            />
          )}
          <div className="absolute bottom-7 left-1/2 transform -translate-x-1/2 w-full">
            <div className="w-full flex justify-center items-center">
              <Stepper
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                totalSteps={actualSteps?.length}
              />
            </div>
          </div>
        </div>
      </div>
      {successmodal && (
        <SuccessModal page="/dashboard" title="Assessment Completed" />
      )}
    </div>
  );
};

const Flow = () => <MainFlow />;

export default Flow;

export const BtnComp = ({
  setActiveStep,
  secondBtn,
  activeStep,
  skipBtn,
  mainBtn,
  mainFunction,
  type,
  loading,
}: {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  secondBtn?: string;
  skipBtn?: string;
  activeStep: number;
  mainBtn?: string;
  mainFunction?: (e?: any) => void;
  type?: "button" | "submit";
  loading?: boolean;
}) => {
  return (
    <>
      <div
        className={`mt-6  gap-2 items-center w-96 grid ${
          skipBtn && secondBtn
            ? "grid-cols-3"
            : skipBtn || secondBtn
            ? "grid-cols-2"
            : "grid-cols-1"
        } `}
      >
        {secondBtn && (
          <PrimaryBtn
            text={secondBtn || "Go Back"}
            width="w-full"
            onClick={() => setActiveStep(activeStep - 1)}
            className="main-shadow main-border h-11 bg-transparent text-es-gray-200 text-base font-medium
					"
            disabled={loading}
          />
        )}
        <PrimaryBtn
          text={mainBtn || "Continue"}
          width="w-full"
          type={type || "button"}
          onClick={(e: any) => {
            if (mainFunction) mainFunction(e);
          }}
          loading={loading}
        />
        {skipBtn && (
          <PrimaryBtn
            text={skipBtn || "Skip"}
            width="w-full"
            onClick={() => setActiveStep(activeStep + 1)}
            className="main-shadow main-border h-11 bg-transparent text-es-gray-200 text-base font-medium
					"
            disabled={loading}
          />
        )}
      </div>
    </>
  );
};

export const ActiveStep0 = ({
  setActiveStep,
  secondBtn,
  activeStep,
  skipBtn,
  actualModule,
  modules,
  setModules,
  setActualModule,
  thisUser,
}: {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  secondBtn?: string;
  skipBtn?: string;
  activeStep: number;
  actualModule: any;
  setModules: React.Dispatch<React.SetStateAction<any[]>>;
  modules: any[];
  setActualModule: React.Dispatch<React.SetStateAction<any>>;
  thisUser?: any;
}) => {
  const init2 = {
    tempId: v4(),
  };
  const [itemForm, setItemForm] = useState([init2]);
  const handleInputChangeForMutipleItem = (
      event: React.ChangeEvent<HTMLInputElement>,
      index: number,
      field: string
    ) => {
      const { value } = event.target;
      let itemValue = value;

      setItemForm((prevRows) => {
        const newRows = [...prevRows];
        newRows[index][field] = itemValue;
        return newRows;
      });
    },
    [getSearch] = useSearchParams(),
    { user } = useAuthStore(),
    navigate = useNavigate(),
    location = useLocation();

  const handleDeleteRowForMutipleItem = (index: number) => {
    setItemForm((prevRows) => {
      const newRows = [...prevRows];
      // newRows.splice(index, 1);
      newRows[index]["isDeleted"] = true;
      return newRows;
    });
  };
  // const handleDeleteRowForMutipleItem = (index: number) => {
  // 	setItemForm(prevRows => {
  // 		const newRows = [...prevRows];
  // 		newRows.splice(index, 1);
  // 		return newRows;
  // 	});
  // };

  const addRowForMutipleItem = () => {
      const newRow = init2;
      setItemForm([...itemForm, newRow]);
    },
    { onSubmitAPI, loading } = useApiCall();

  const handleSubmit = async (e: any) => {
    if (!getSearch?.get("email") && !user) {
      navigate("/");
    } else {
      const emailRaw = location.search.match(/[?&]email=([^&]+)/)?.[1]; // get raw encoded value
      const email = decodeURIComponent(emailRaw?.replace(/\+/g, "%2B") || "");

      let thisEmail = user?.user?.email;
      if (getSearch?.get("email")) thisEmail = email || getSearch?.get("email");
      if (!itemForm?.every((it: any) => it?.erpModule))
        return toast.error("All Erp Modules required");

      let newData = [...itemForm]?.filter((it) => !(it as any)?.isDeleted);
      if (newData?.length === 0) return toast.error("All Erp Modules required");
      e?.preventDefault();
      await onSubmitAPI({
        url: `/api/v1/data-system`,
        type: "put",
        data: {
          datasystems: itemForm,
          email: thisEmail,
          user: thisUser?.user?._id,
        },
        // toggleModal: () => {
        // 	// setModal("success");
        // },
        setResponse: (d: any) => {
          let dd = d?.data || d;
          setModules(dd);
          setActualModule(dd?.[0]);
          setActiveStep(activeStep + 1);
        },
      });
    }
  };

  useEffect(() => {
    setItemForm(modules);
    setActualModule(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modules]);

  // const handleSubmit = async (e: any) => {
  // 	e?.preventDefault();
  // 	if (!itemForm?.every((it: any) => it?.erpModule))
  // 		return toast.error("All Erp Modules required");

  // 	let newData = [...itemForm]?.filter(it => !(it as any)?.isDeleted);
  // 	if (newData?.length === 0) return toast.error("All Erp Modules required");
  // 	console.log({ itemForm, newData });
  // 	setModules(newData);
  // 	setActualModule(newData?.[0]);
  // 	setActiveStep(activeStep + 1);
  // };

  return (
    <>
      <div>
        <h2 className="text-3xl font-semibold text-sec">Data Systems</h2>
        <p className="mt-1 text-sm text-es-gray-100 font-normal">
          Complete details correctly.
        </p>
        {/* <button className="h-11 w-44 mt-6 rounded-lg bg-[#E8EEF3] main-shadow main-border capitalize text-base font-medium text-[#3F516C]">
		{actualModule?.erpModule}
	</button> */}
        <form onSubmit={handleSubmit} className="mt-6">
          <h5 className="my-2 text-base font-semibold text-sec">
            Data Systems
          </h5>
          <div className="space-y-4 w-96">
            {itemForm
              ?.filter((it: any) => !it?.isDeleted)
              ?.map((item: any, i: number) => (
                <div key={i} className="flex items-center my-2">
                  {itemForm?.filter((it: any) => !it?.isDeleted)?.length > 1 ? (
                    <span
                      className="mr-3 text-red-500 cursor-pointer"
                      onClick={() => {
                        if (
                          itemForm?.filter((it: any) => !it?.isDeleted)
                            ?.length > 1
                        )
                          handleDeleteRowForMutipleItem(i);
                      }}
                    >
                      <FaTrash />{" "}
                    </span>
                  ) : (
                    ""
                  )}
                  <Input
                    label={
                      "Individually list all the data systems in use by the department*"
                    }
                    placeholder="PASTEL"
                    name={"erpModule"}
                    value={item?.erpModule}
                    type={"text"}
                    onChange={(e) =>
                      handleInputChangeForMutipleItem(e, i, "erpModule")
                    }
                  />
                </div>
              ))}
          </div>
          <div
            onClick={addRowForMutipleItem}
            className="mt-4 cursor-pointer flex gap-1 items-center"
          >
            <img src={Plus} alt="" className="" />
            <small className="text-sm text-primary font-normal">
              Add another
            </small>
          </div>
          {/* <div className="mt-6 w-96">
			<PrimaryBtn text="Continue" width="w-full" onClick={() => {}} />
		</div> */}
          <BtnComp
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            // skipBtn="Skip"
            type="submit"
            loading={!!loading}
          />
        </form>
      </div>
    </>
  );
};

export const ActiveStep1 = ({
  setActiveStep,
  activeStep,
  actualModule,
  textChange,
  requiredKeys,
}: {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  secondBtn?: string;
  skipBtn?: string;
  activeStep: number;
  actualModule: any;
  textChange: (e: any) => any;
  requiredKeys: string[];
}) => {
  const handleSubmit = async (e: any) => {
      e?.preventDefault();
      if (!requiredKeys?.every((key) => isValid(actualModule[key])))
        return toast.error("All Details required");

      setActiveStep(activeStep + 1);
    },
    { currencies } = useGetCountryCurrencySystem();

  return (
    <>
      <div className="">
        <h2 className="text-3xl font-semibold text-sec">Data Systems</h2>
        <p className="mt-1 text-sm text-es-gray-100 font-normal">
          Complete details correctly
        </p>
        {/* <button className="h-11 w-44 mt-6 rounded-lg bg-[#E8EEF3] main-shadow main-border capitalize text-base font-medium text-[#3F516C]">
		{actualModule?.erpModule}
	</button> */}
        <form onSubmit={handleSubmit} className="mt-6">
          <h5 className="my-2 text-base font-semibold text-sec">
            Data Systems
          </h5>
          <div className="space-y-4 w-9/12">
            <Input
              readonly={true}
              label="Data system in use by the department*"
              placeholder="ERP Module"
              value={actualModule?.erpModule}
            />
            <Input
              label="Name of the system developer*"
              placeholder="E.g. Sage, In-house etc"
              name={"systemDeveloper"}
              value={actualModule?.systemDeveloper}
              type={"text"}
              onChange={textChange}
            />
            <Input
              label="Date of first installation*"
              placeholder=" Enter Date Installed"
              name={"dateInstalled"}
              value={actualModule?.dateInstalled}
              type={"date"}
              onChange={textChange}
            />
            <div className="flex gap-2 items-center">
              <div className="w-32">
                {currencies && currencies?.length > 0 ? (
                  <MultiSelectDropdown
                    placeholder="Select options..."
                    label="Currency"
                    options={currencies?.map((it) => {
                      return {
                        label: it,
                        value: it,
                      };
                    })}
                    onChange={(sel) => {
                      textChange({
                        target: {
                          value: sel,
                          name: "annualLicenseFeeCurrency",
                        },
                      });
                    }}
                    defaultValue={actualModule?.annualLicenseFeeCurrency}
                    defaultType="radio"
                  />
                ) : (
                  <Input
                    label="Currency"
                    // placeholder="Enter Annual License Fees"
                    name={"annualLicenseFeeCurrency"}
                    value={actualModule?.annualLicenseFeeCurrency || ""}
                    onChange={textChange}
                    setState={(d: any) => {
                      textChange({
                        target: {
                          value: d,
                          name: "annualLicenseFee",
                        },
                      });
                    }}
                  />
                )}
              </div>
              <Input
                label="Amount paid for annual license fees or maintenance*"
                placeholder="Enter Annual License Fees"
                name={"annualLicenseFee"}
                value={actualModule?.annualLicenseFee}
                type={"number"}
                onChange={textChange}
                setState={(d: any) => {
                  textChange({
                    target: {
                      value: d,
                      name: "annualLicenseFee",
                    },
                  });
                }}
                noFormat
              />
            </div>
            <Input
              label="Describe the main purpose of the system*"
              placeholder="e.g. Billing, NRW management, Payroll"
              name={"systemPurpose"}
              value={actualModule?.systemPurpose}
              type={"text"}
              onChange={textChange}
            />
          </div>
          <BtnComp
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            // skipBtn="Skip"
            secondBtn="Go Back"
            type="submit"
          />
        </form>
      </div>
    </>
  );
};

export const ActiveStep2 = ({
  setActiveStep,
  activeStep,
  actualModule,
  requiredKeys,
  textChange,
}: {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  secondBtn?: string;
  skipBtn?: string;
  activeStep: number;
  actualModule: any;
  textChange: (e: any) => any;
  requiredKeys: string[];
}) => {
  const handleSubmit = async (e: any) => {
    e?.preventDefault();
    if (!requiredKeys?.every((key) => isValid(actualModule[key])))
      return toast.error("All Details required");

    setActiveStep(activeStep + 1);
  };

  return (
    <>
      <div>
        <h2 className="text-3xl font-semibold text-sec">Data Collection</h2>
        <p className="mt-1 text-sm text-es-gray-100 font-normal">
          Complete form correctly
        </p>
        {/* <button className="h-11 w-44 mt-6 rounded-lg bg-[#E8EEF3] main-shadow main-border capitalize text-base font-medium text-[#3F516C]">
		{actualModule?.erpModule}
	</button> */}
        <form onSubmit={handleSubmit} className="mt-6">
          <h5 className="my-2 text-base font-semibold text-sec hidden">
            Data Collection Tool
          </h5>
          <div className="space-y-4 w-96">
            <Input
              // readonly={true}
              label="Name of the tool used to collect data*"
              placeholder="E.g. mobile meter reading app"
              name={"toolUsedToCollectData"}
              value={actualModule?.toolUsedToCollectData}
              type={"text"}
              onChange={textChange}
            />

            <MultiSelectDropdown
              label="What technology is used by the tool to collect information*"
              placeholder="Select Technology..."
              options={informationCollectionToolList?.map((it) => {
                return {
                  label: it,
                  value: it,
                };
              })}
              onChange={(sel) => {
                textChange({
                  target: {
                    value: sel,
                    name: "informationCollectionTool",
                  },
                });
              }}
              // defaultValue={actualModule?.informationCollectionTool}
              defaultType="radio"
              defaultValue={
                Array.isArray(actualModule?.informationCollectionTool)
                  ? actualModule?.informationCollectionTool?.[0]
                  : actualModule?.informationCollectionTool
              }
            />
            <MultiSelectDropdown
              label="How often is data collected*"
              placeholder="Select Frequency..."
              options={oftenCollectedList?.map((it) => {
                return {
                  label: it,
                  value: it,
                };
              })}
              defaultType="radio"
              onChange={(sel) => {
                textChange({
                  target: {
                    value: sel,
                    name: "oftenCollected",
                  },
                });
              }}
              defaultValue={
                Array.isArray(actualModule?.oftenCollected)
                  ? actualModule?.oftenCollected?.[0]
                  : actualModule?.oftenCollected
              }
            />
            <MultiSelectDropdown
              label="How well does the data collection tool serve its purpose?  "
              placeholder="Select Option..."
              options={effectivenessList?.map((it) => {
                return {
                  label: it,
                  value: it,
                };
              })}
              defaultType="radio"
              onChange={(sel) => {
                textChange({
                  target: {
                    value: sel,
                    name: "dataCollectionToolPurposeServe",
                  },
                });
              }}
              defaultValue={
                Array.isArray(actualModule?.dataCollectionToolPurposeServe)
                  ? actualModule?.dataCollectionToolPurposeServe?.[0]
                  : actualModule?.dataCollectionToolPurposeServe
              }
            />
          </div>
          <BtnComp
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            // skipBtn="Skip"
            secondBtn="Go Back"
            type="submit"
          />
        </form>
      </div>
    </>
  );
};

export let deptsFeedDataSystem = [
  "IT",
  "Legal",
  "Procurement",
  "HR",
  "Finance",
  "Commercial",
  "Engineering",
];

export const ActiveStep3 = ({
  setActiveStep,
  activeStep,
  actualModule,
  requiredKeys,
  textChange,
  departmentSystem,
  departmentSystem2,
  setUseCase,
}: // thisUser,
{
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  secondBtn?: string;
  skipBtn?: string;
  activeStep: number;
  actualModule: any;
  textChange: (e: any) => any;
  requiredKeys: string[];
  departmentSystem: any;
  departmentSystem2: any;
  thisUser: any;
  setUseCase: React.Dispatch<
    React.SetStateAction<"deptsFeedDataSystem" | "deptReceiveData">
  >;
}) => {
  const handleSubmit = async (e: any) => {
      e?.preventDefault();
      if (!requiredKeys?.every((key) => isValid(actualModule[key])))
        return toast.error("All Details required");

      setActiveStep(activeStep + 1);
    },
    departmentList = departmentSystem?.docs
      ?.find((it: any) => it?.category === "departmentName")
      ?.data?.sort(
        (
          a: { title: { toString: () => string } },
          b: { title: { toString: () => any } }
        ) => {
          // Compare the values of the specified key in a case-insensitive manner
          return a?.title?.toString()?.localeCompare(b?.title?.toString());
        }
      ),
    erpModuleList = departmentSystem?.docs
      ?.find((it: any) => it?.category === "erpModule")
      ?.data?.sort(
        (
          a: { title: { toString: () => string } },
          b: { title: { toString: () => any } }
        ) => {
          // Compare the values of the specified key in a case-insensitive manner
          return a?.title?.toString()?.localeCompare(b?.title?.toString());
        }
      ),
    erpModule2List = departmentSystem2?.docs
      ?.find((it: any) => it?.category === "erpModule")
      ?.data?.sort(
        (
          a: { title: { toString: () => string } },
          b: { title: { toString: () => any } }
        ) => {
          // Compare the values of the specified key in a case-insensitive manner
          return a?.title?.toString()?.localeCompare(b?.title?.toString());
        }
      ),
    naList = [
      {
        value: "N/A",
        label: "N/A",
      },
    ];

  return (
    <>
      <div>
        <h2 className="text-3xl font-semibold text-sec">
          Data Flow and Visualisation
          {/* <br /> */}
        </h2>
        <p className="mt-1 text-sm text-es-gray-100 font-normal">
          Complete form correctly
        </p>
        {/* <button className="h-11 w-44 mt-6 rounded-lg bg-[#E8EEF3] main-shadow main-border capitalize text-base font-medium text-[#3F516C]">
		{actualModule?.erpModule}
	</button> */}
        <form onSubmit={handleSubmit} className="mt-6">
          <h5 className="my-2 text-base font-semibold text-sec hidden">
            Data Collection Tool
          </h5>
          <div className="space-y-4 w-96">
            <MultiSelectDropdown
              label="Which department feeds data to this system*"
              placeholder="Select Option..."
              options={
                departmentList
                  ? [
                      ...departmentList?.map((it: any) => {
                        return {
                          label: it?.title,
                          value: it?.title,
                        };
                      }),
                      ...naList,
                    ]
                  : naList
              }
              onChange={(sel) => {
                setUseCase("deptsFeedDataSystem");
                textChange({
                  target: {
                    value: sel,
                    name: "deptsFeedDataSystem",
                  },
                });
              }}
              defaultValue={
                Array.isArray(actualModule?.deptsFeedDataSystem)
                  ? actualModule?.deptsFeedDataSystem
                  : []
              }
            />
            <MultiSelectDropdown
              label={`Which system feeds data to this system${
                erpModuleList?.length > 0 ? "*" : ""
              }`}
              placeholder="Select Option..."
              options={
                erpModuleList
                  ? [
                      ...erpModuleList?.map((it: any) => {
                        return {
                          label: it?.title,
                          value: it?.title,
                        };
                      }),
                      ...naList,
                    ]
                  : naList
              }
              onChange={(sel) => {
                textChange({
                  target: {
                    value: sel,
                    name: "systemsFeedDataSystem",
                  },
                });
              }}
              defaultValue={
                Array.isArray(actualModule?.systemsFeedDataSystem)
                  ? actualModule?.systemsFeedDataSystem
                  : []
              }
            />
            {/* <Input
									placeholder="E.g. Finances"
									name={"deptReceiveData"}
									value={actualModule?.deptReceiveData}
									type={"text"}
									onChange={textChange}
									/> */}
            <MultiSelectDropdown
              label="Which department receives data from this system?*"
              placeholder="Select Option..."
              options={
                departmentList
                  ? [
                      ...departmentList?.map((it: any) => {
                        return {
                          label: it?.title,
                          value: it?.title,
                        };
                      }),
                      ...naList,
                    ]
                  : naList
              }
              onChange={(sel) => {
                setUseCase("deptReceiveData");
                textChange({
                  target: {
                    value: sel,
                    name: "deptReceiveData",
                  },
                });
              }}
              defaultValue={
                Array?.isArray(actualModule?.deptReceiveData)
                  ? actualModule?.deptReceiveData
                  : []
              }
            />
            <MultiSelectDropdown
              label={`Which system receives data from this system?${
                erpModule2List?.length > 0 ? "*" : ""
              }`}
              placeholder="Select Option..."
              options={
                erpModule2List
                  ? [
                      ...erpModule2List?.map((it: any) => {
                        return {
                          label: it?.title,
                          value: it?.title,
                        };
                      }),
                      ...naList,
                    ]
                  : naList
              }
              onChange={(sel) => {
                textChange({
                  target: {
                    value: sel,
                    name: "systemReceiveData",
                  },
                });
              }}
              defaultValue={
                Array.isArray(actualModule?.systemReceiveData)
                  ? actualModule?.systemReceiveData
                  : []
              }
              // placeholder="E.g. Commercial-billing system-customers "
            />
            {/* <Input
							label="Which system receive data from this system?"
							placeholder="E.g. Commercial-billing system-customers "
							name={"systemReceiveData"}
							value={actualModule?.systemReceiveData}
							type={"text"}
							onChange={textChange}
						/> */}
            <TextArea
              label="What reports are produced for decision-making?*"
              placeholder="Financial performance reports"
              name={"reportProduced"}
              value={actualModule?.reportProduced}
              type={"text"}
              onChange={textChange}
            />
          </div>
          <BtnComp
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            // skipBtn="Skip"
            secondBtn="Go Back"
            type="submit"
          />
        </form>
      </div>
    </>
  );
};

export const ActiveStep4 = ({
  setActiveStep,
  activeStep,
  actualModule,
  requiredKeys,
  textChange,
  departmentSystem,
}: {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  secondBtn?: string;
  skipBtn?: string;
  activeStep: number;
  actualModule: any;
  textChange: (e: any) => any;
  requiredKeys: string[];
  departmentSystem: any;
}) => {
  const handleSubmit = async (e: any) => {
      e?.preventDefault();
      if (!requiredKeys?.every((key) => isValid(actualModule[key])))
        return toast.error("All Details required");

      setActiveStep(activeStep + 1);
    },
    { getDynamicLogger } = useRequestStore(),
    { systemInformAreaListData }: any = useRequestStore();

  useEffect(() => {
    apiCall({
      type: "get",
      url: `/api/v1/system-inform-area?pagination=not`,
      getter: (d: any) => getDynamicLogger(d, "systemInformAreaListData"),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div>
        <h2 className="text-3xl font-semibold text-sec">
          External Data Sharing
        </h2>
        <p className="mt-1 text-sm text-es-gray-100 font-normal">
          Complete form correctly
        </p>
        {/* <button className="h-11 w-44 mt-6 rounded-lg bg-[#E8EEF3] main-shadow main-border capitalize text-base font-medium text-[#3F516C]">
		{actualModule?.erpModule}
	</button> */}
        <form onSubmit={handleSubmit} className="mt-6">
          <div className="space-y-4 w-96">
            <MultiSelectDropdown
              placeholder="Select Option..."
              label="Which KPI does this system inform?*"
              options={systemInformKPIList?.map((it) => {
                return {
                  label: it,
                  value: it,
                };
              })}
              onChange={(sel) => {
                textChange({
                  target: {
                    value: sel,
                    name: "systemInformKPI",
                  },
                });
              }}
              defaultValue={actualModule?.systemInformKPI}
              isOthersAddable
            />
            <MultiSelectDropdown
              label="Which Area does this system inform?*"
              placeholder="Select Option..."
              options={(
                systemInformAreaListData?.docs || systemInformAreaList
              )?.map((it: any) => {
                return {
                  label: it?.title || it,
                  value: it?.title || it,
                };
              })}
              onChange={(sel) => {
                textChange({
                  target: {
                    value: sel,
                    name: "systemInformArea",
                  },
                });
              }}
              defaultValue={actualModule?.systemInformArea}
            />
            <TextArea
              name={"deptSystemReceiveData"}
              value={actualModule?.deptSystemReceiveData}
              type={"text"}
              onChange={textChange}
              label="Which external department and system receives data from this system?*"
              placeholder="Enter the  external system for which data from this system is extracted and submitted to an external party e.g, MWDS Digital Atlas"
            />
            {/* <MultiSelectDropdown
							label="Which external department and system receives data from this system?"
							placeholder="Enter the  external system for which data from this system is extracted and submitted to an external party e.g, MWDS Digital Atlas"
							options={departmentSystem?.docs
								?.find((it: any) => it?.category === "departmentName")
								?.data?.sort(
									(
										a: { title: { toString: () => string } },
										b: { title: { toString: () => any } }
									) => {
										// Compare the values of the specified key in a case-insensitive manner
										return a?.title
											?.toString()
											?.localeCompare(b?.title?.toString());
									}
								)
								?.map((it: any) => {
									return {
										label: it?.title,
										value: it?.title,
									};
								})}
							onChange={sel => {
								textChange({
									target: {
										value: sel,
										name: "deptSystemReceiveData",
									},
								});
							}}
							defaultValue={
								Array?.isArray(actualModule?.deptSystemReceiveData)
									? actualModule?.deptSystemReceiveData
									: []
							}
						/> */}
            <MultiSelectDropdown
              label="How effective is the communication between this system and the one that feeds it information?*"
              placeholder="Select Option..."
              options={effectivenessList?.map((it) => {
                return {
                  label: it,
                  value: it,
                };
              })}
              defaultType="radio"
              onChange={(sel) => {
                textChange({
                  target: {
                    value: sel,
                    name: "systemCommunicationEffectiveness",
                  },
                });
              }}
              defaultValue={
                Array.isArray(actualModule?.systemCommunicationEffectiveness)
                  ? actualModule?.systemCommunicationEffectiveness?.[0]
                  : actualModule?.systemCommunicationEffectiveness
              }
            />
          </div>
          <BtnComp
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            // skipBtn="Skip"
            secondBtn="Go Back"
            type="submit"
          />
        </form>
      </div>
    </>
  );
};

export const ActiveStep5 = ({
  setActiveStep,
  activeStep,
  actualModule,
  requiredKeys,
  textChange,
}: {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  secondBtn?: string;
  skipBtn?: string;
  activeStep: number;
  actualModule: any;
  textChange: (e: any) => any;
  requiredKeys: string[];
}) => {
  const handleSubmit = async (e: any) => {
    e?.preventDefault();
    if (!requiredKeys?.every((key) => isValid(actualModule[key])))
      return toast.error("All Details required");

    setActiveStep(activeStep + 1);
  };

  return (
    <>
      <div>
        <h2 className="text-3xl font-semibold text-sec">Fit for Purpose</h2>
        <p className="mt-1 text-sm text-es-gray-100 font-normal">
          Complete form correctly
        </p>
        {/* <button className="h-11 w-44 mt-6 rounded-lg bg-[#E8EEF3] main-shadow main-border capitalize text-base font-medium text-[#3F516C]">
		{actualModule?.erpModule}
	</button> */}
        <form onSubmit={handleSubmit} className="mt-6">
          <div className="space-y-4 w-96">
            <MultiSelectDropdown
              label="Level of effectiveness for purpose*"
              placeholder="Select Option..."
              options={effectivenessList?.map((it) => {
                return {
                  label: it,
                  value: it,
                };
              })}
              defaultType="radio"
              onChange={(sel) => {
                textChange({
                  target: {
                    value: sel,
                    name: "effectivenessPurposeLevel",
                  },
                });
              }}
              defaultValue={
                Array.isArray(actualModule?.effectivenessPurposeLevel)
                  ? actualModule?.effectivenessPurposeLevel?.[0]
                  : actualModule?.effectivenessPurposeLevel
              }
            />
            <MultiSelectDropdown
              label="Data Security*"
              placeholder="Select Option..."
              options={dataSecurityList?.map((it) => {
                return {
                  label: it,
                  value: it,
                };
              })}
              onChange={(sel) => {
                textChange({
                  target: {
                    value: sel,
                    name: "dataSecurity",
                  },
                });
              }}
              defaultType="radio"
              defaultValue={
                Array.isArray(actualModule?.dataSecurity)
                  ? actualModule?.dataSecurity?.[0]
                  : actualModule?.dataSecurity
              }
            />
            <Input
              label="Support and Training Needs"
              placeholder="Enter"
              name={"supportTainingNeeds"}
              value={actualModule?.supportTainingNeeds}
              type={"text"}
              onChange={textChange}
            />
            <Input
              label="Improvements required"
              placeholder="Enter"
              name={"improvementRequired"}
              value={actualModule?.improvementRequired}
              type={"text"}
              onChange={textChange}
            />
          </div>
          <BtnComp
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            // skipBtn="Skip"
            secondBtn="Go Back"
            type="submit"
          />
        </form>
      </div>
    </>
  );
};

export const ActiveStep6 = ({
  setActiveStep,
  secondBtn,
  activeStep,
  skipBtn,
  actualModule,
  setSuccessmodal,
  setActiveTab,
  activeTab,
  thisUser,
  setActualModule,
  setModules,
}: {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  setSuccessmodal: React.Dispatch<React.SetStateAction<boolean>>;
  secondBtn?: string;
  skipBtn?: string;
  activeStep: number;
  actualModule: any;
  setActiveTab: (value: React.SetStateAction<string>) => void;
  activeTab: string;
  thisUser?: any;
  setModules: React.Dispatch<React.SetStateAction<any[]>>;
  modules: any[];
  setActualModule: React.Dispatch<React.SetStateAction<any>>;
}) => {
  let [getSearch] = useSearchParams(),
    { user } = useAuthStore(),
    navigate = useNavigate(),
    { onSubmitAPI, loading } = useApiCall(),
    location = useLocation();

  const handleSubmit = async (e: any) => {
    if (!getSearch?.get("email") && !user) {
      navigate("/");
    } else {
      const emailRaw = location.search.match(/[?&]email=([^&]+)/)?.[1]; // get raw encoded value
      const email = decodeURIComponent(emailRaw?.replace(/\+/g, "%2B") || "");

      let thisEmail = user?.user?.email;
      if (getSearch?.get("email")) thisEmail = email || getSearch?.get("email");
      if (!actualModule?._id) return toast.error("Erp Modules required");

      e?.preventDefault();
      await onSubmitAPI({
        url: `/api/v1/data-system`,
        type: "post",
        data: {
          datasystems: [actualModule],
          email: thisEmail,
          user: thisUser?.user?._id,
        },

        setResponse: (d: any) => {
          let dd = d?.data || d;
          setModules(dd);

          function findNextOrLogic(array: any[], targetId: string) {
            const index = array.findIndex((item) => item._id === targetId);

            if (index !== -1) {
              if (index + 1 < array.length) {
                // Next object exists
                setActualModule(array[index + 1]);
                setActiveStep(1);
                // return array[index + 1];
              } else {
                setSuccessmodal(true);
              }
            }
            //  else {
            // 	return "Target object not found.";
            // }
          }
          findNextOrLogic(dd, actualModule?._id);
        },
      });
    }
  };
  return (
    <>
      <div className="">
        <h2 className="text-3xl font-semibold text-sec">Preview</h2>
        <p className="mt-1 text-sm text-es-gray-100 font-normal">
          Kindly check that all information filled is correct.
        </p>
        <div className="mt-5 bg-[#F9FAFB] h-11 rounded-lg items-center flex p-2 space-x-6 ">
          {tabItems.map((it) => (
            <button
              onClick={() => setActiveTab(it?.name)}
              className={`${
                activeTab === it?.name
                  ? "bg-white main-shadow text-[#344054] h-9 px-4"
                  : "bg-transparent text-[#667085"
              }`}
            >
              {it?.name}
            </button>
          ))}
        </div>
        <div>
          <div>
            <div className="flex gap-4 mt-3 items-center">
              <h5 className="text-lg font-semibold text-[#101828]">
                {tabItems?.find((it) => it?.name === activeTab)?.name}
                {tabItems?.find((it) => it?.name === activeTab)?.name ===
                "About"
                  ? " Data Systems"
                  : ""}
              </h5>
              <p
                onClick={() =>
                  setActiveStep(
                    tabItems?.find((it) => it?.name === activeTab)?.step
                  )
                }
                className="text-sm cursor-pointer text-[#2070B8] underline"
              >
                Edit Details
              </p>
            </div>
            <div className="mt-4 space-y-4">
              {tabItems
                ?.find((it) => it?.name === activeTab)
                ?.data.map((it, idx) => (
                  <div key={idx} className="">
                    <h5 className="text-sm font-mediun text-[#3B3B3B]">
                      {it?.question}
                    </h5>
                    <p className="text-sm font-medium text-[#667085] max-w-2xl">
                      {Array.isArray(actualModule?.[it?.key]) ? (
                        actualModule?.[it?.key]?.join(", ")
                      ) : (it as any)?.type === "number" ? (
                        <>
                          {(it as any)?.subkey
                            ? actualModule?.[(it as any)?.subkey] || ``
                            : ``}
                          {numberWithCommas(
                            Number(actualModule?.[it?.key]).toFixed(2)
                          )}
                        </>
                      ) : (it as any)?.type === "date" ? (
                        moment(actualModule?.[it?.key]).format("MMMM DD, YYYY")
                      ) : (
                        actualModule?.[it?.key]
                      )}
                    </p>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <BtnComp
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          // skipBtn="Skip"
          secondBtn="Go Back"
          mainBtn="Submit"
          // mainFunction={() => {
          // 	if (process.env.NODE_ENV !== "development") setSuccessmodal(true);
          // }}
          mainFunction={handleSubmit}
          loading={!!loading}
        />
      </div>
    </>
  );
};

export const useGetDepartmentSystem = ({
  systemSelection,
  thisUser,
  usecase = "deptsFeedDataSystem",
}: {
  systemSelection?: any;
  thisUser: any;
  usecase?: "deptReceiveData" | "deptsFeedDataSystem";
}) => {
  const { getDynamicLogger } = useRequestStore(),
    { departmentSystem, departmentSystem2 }: any = useRequestStore(),
    [getSearch] = useSearchParams(),
    { user } = useAuthStore(),
    location = useLocation();

  useEffect(() => {
    if (!thisUser) return;
    const emailRaw = location.search.match(/[?&]email=([^&]+)/)?.[1]; // get raw encoded value
    const email = decodeURIComponent(emailRaw?.replace(/\+/g, "%2B") || "");

    let thisEmail = user?.user?.email;
    if (getSearch?.get("email")) thisEmail = email || getSearch?.get("email");
    let newObj: any;

    if (systemSelection?.[usecase] && systemSelection?.[usecase]?.length > 0) {
      newObj = { departmentName: systemSelection?.[usecase] };
      // if (
      // 	!defaultSelection?.["COUNTRY"] ||
      // 	defaultSelection?.["COUNTRY"]?.length === 0
      // )
      // 	handleReset("COUNTRY", "checkbox");
    }
    let restProp: any = {
      email: thisEmail,
      user: thisUser?.user?._id,
    };

    let conditional = newObj && Object?.entries(newObj)?.length > 0;
    if (conditional)
      restProp.systemSelection = Object.entries(newObj)
        .map(([key, value]) => ({
          category: key,
          data: Array.isArray(value) ? value : [value], // Ensure data is always an array
        }))
        ?.filter((it) => it?.data?.length > 0);
    apiCall({
      type: conditional ? "post" : "get",
      url: `/api/v1/data-system/manage-department-system?pagination=not${
        !conditional
          ? `&email=${encodeURIComponent(restProp?.email)}&user=${
              restProp?.user
            }`
          : ""
      }${systemSelection?._id ? `&datasystem=${systemSelection?._id}` : ""}`,
      data: restProp,
      getter: (d: any) =>
        getDynamicLogger(
          d,
          usecase === "deptReceiveData"
            ? "departmentSystem2"
            : "departmentSystem"
        ),
      noToast: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    systemSelection?.deptsFeedDataSystem,
    thisUser,
    systemSelection?.deptReceiveData,
  ]);

  return { departmentSystem, departmentSystem2 };
};

const getCountries = async ({ setCountries }: { setCountries: any }) => {
  fetch("https://restcountries.com/v3.1/all?fields=name,capital,currencies")
    .then((response) => response.json())
    .then((data) => {
      setCountries(data);
    })
    .catch((error) => {
      console.error("Error fetching countries:", error);
    });
};

export const useGetCountryCurrencySystem = () => {
  const { getDynamicLogger, countryCurrency }: any = useRequestStore(),
    [currencies, setCurrencies] = useState<string[]>([]);

  useEffect(() => {
    getCountries({
      setCountries: (d: any) => getDynamicLogger(d, "countryCurrency"),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (countryCurrency) {
      // let newCurrency1: string[] = countryCurrency?.map((it: any) => {
      // 	let value1 = it?.currencies,
      // 		value2 = Object.keys(value1),
      // 		value3 = value1?.[value2?.[0]]?.symbol;

      // 	return value3;
      // });
      let newCurrency1 = countryCurrency.flatMap((country: any) =>
        Object.keys(country?.currencies || {})
      );

      let uniqueCurrencies: string[] = Array.from(
        new Set(newCurrency1?.filter((it) => it))
      );

      setCurrencies(uniqueCurrencies);
    }
  }, [countryCurrency]);

  return { currencies };
};
